<script setup lang="ts">
  defineProps<{
    placeholder: string
    error?: string
    label?: string
    disabled?: boolean,
  }>()

  const model = defineModel<string>()
  const show = ref(false)
</script>

<template>
  <div class="flex flex-col gap-1">
    <label v-if="label" class="text-sm">
      {{ label }}
    </label>

    <UInput
      v-model="model"
      class="flex w-full"
      :placeholder="placeholder"
      :disabled="disabled"
      :type="show ? 'text' : 'password'"
      :ui="{
        base: `py-2.5 px-4 !text-black/80 dark:!text-white/80 ${
          error ? 'ring-2 !ring-red-500' : ''
        }`,
      }"
    >
      <template #trailing>
        <UIcon :name="show ? 'i-lucide-eye-off' : 'i-lucide-eye'" class="shrink-0 text-dimmed min-w-5 size-5"    @click="show = !show"/>
      </template>
    </UInput>

    <p v-if="error" class="text-red-600 dark:text-red-500">
      {{ error }}
    </p>
  </div>
</template>

<style>
  ::-ms-reveal {
    display: none;
  }
</style>
